import { createContext, useContext, useMemo } from 'react';

type DefaultSuccessHandlersContextType = {
  defaultSuccessHandler: () => Promise<void>;
};

const DefaultSuccessHandlersContext =
  createContext<DefaultSuccessHandlersContextType>({
    defaultSuccessHandler: async () => {},
  });

export const DefaultSuccessHandlersProvider = ({
  defaultSuccessHandler,
  children,
}: {
  defaultSuccessHandler: () => Promise<void>;
  children: React.ReactNode;
}) => {
  const value = useMemo(
    () => ({
      defaultSuccessHandler,
    }),
    [defaultSuccessHandler],
  );

  return (
    <DefaultSuccessHandlersContext.Provider value={value}>
      {children}
    </DefaultSuccessHandlersContext.Provider>
  );
};

export const useDefaultSuccessHandlers = () => {
  return useContext(DefaultSuccessHandlersContext);
};
